import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { TableHeader, TableHeaderCell, TextLabel } from "@opensea/ui-kit";
import { head } from "es-toolkit/array";
import { useTranslations } from "use-intl";
import { CancelOrderTableHeaderFragment } from "./CancelOrderTableHeader.fragment";
import { CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES } from "./constants";
export const CancelOrderTableHeader = t0 => {
  const $ = _c(31);
  const {
    orders: orderKeys
  } = t0;
  const t = useTranslations("wallet.CancelOrderTableHeader");
  let T0;
  let T1;
  let T2;
  let isListing;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== orderKeys || $[1] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const orders = orderKeys.map(_temp);
      const side = head(orders)?.side;
      if (!side) {
        t6 = null;
        break bb0;
      }
      isListing = side === "LISTING";
      T2 = TableHeader;
      t5 = "bg-transparent";
      T1 = TableHeaderCell;
      t4 = CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.item;
      T0 = TextLabel;
      t1 = "xs";
      t2 = "semibold";
      t3 = isListing ? t("listingCount", {
        count: orders.length
      }) : t("offerCount", {
        count: orders.length
      });
    }
    $[0] = orderKeys;
    $[1] = t;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = isListing;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    isListing = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[12] !== T0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t7 = <T0 size={t1} weight={t2}>{t3}</T0>;
    $[12] = T0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== T1 || $[18] !== t4 || $[19] !== t7) {
    t8 = <T1 className={t4}>{t7}</T1>;
    $[17] = T1;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== isListing || $[22] !== t) {
    t9 = isListing ? t("listingPrice") : t("offerPrice");
    $[21] = isListing;
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <TableHeaderCell className={CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.price}><TextLabel size="xs" weight="semibold">{t9}</TextLabel></TableHeaderCell>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== T2 || $[27] !== t10 || $[28] !== t5 || $[29] !== t8) {
    t11 = <T2 className={t5}>{t8}{t10}</T2>;
    $[26] = T2;
    $[27] = t10;
    $[28] = t5;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
function _temp(orderKey) {
  return readFragment(CancelOrderTableHeaderFragment, orderKey);
}